(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-studio-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initPress = () => {
      document.querySelectorAll('.cb-press').forEach((press) => {
        const track = press.querySelector('.cb-press-track');
        const prev = press.querySelector('[data-press-prev]');
        const next = press.querySelector('[data-press-next]');
        if (!track || !prev || !next || press.dataset.pressReady === 'true') return;
        press.dataset.pressReady = 'true';

        const originals = Array.from(track.children);
        originals.forEach((item) => track.appendChild(item.cloneNode(true)));
        originals.slice().reverse().forEach((item) => track.insertBefore(item.cloneNode(true), track.firstChild));

        let index = originals.length;
        let timer;
        let direction = 1;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const render = (animate = true) => {
          const itemWidth = track.children[0]?.getBoundingClientRect().width || 0;
          track.style.transition = animate ? 'transform 1.1s cubic-bezier(.22,.61,.36,1)' : 'none';
          track.style.setProperty('--cb-press-offset', (index * itemWidth) + 'px');
        };

        const normalize = () => {
          const n = originals.length;
          if (index >= n * 2) {
            index -= n;
            render(false);
          } else if (index < n) {
            index += n;
            render(false);
          }
        };

        const step = (dir) => {
          direction = dir;
          index += dir;
          render(true);
          window.setTimeout(normalize, 1150);
        };

        const start = () => {
          clearInterval(timer);
          if (!reduceMotion.matches) timer = window.setInterval(() => step(1), 5200);
        };

        next.addEventListener('click', () => { step(1); start(); });
        prev.addEventListener('click', () => { step(-1); start(); });

        track.addEventListener('transitionend', () => normalize());
        press.addEventListener('mouseenter', () => clearInterval(timer));
        press.addEventListener('mouseleave', start);
        press.addEventListener('focusin', () => clearInterval(timer));
        press.addEventListener('focusout', start);

        render(false);
        start();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPress, { once: true });
    else initPress();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hero__scroll-cue').forEach(function (cue) {
  if (cue.dataset.scrollCueBound) return;
  cue.dataset.scrollCueBound = 'true';

  cue.addEventListener('click', function () {
    var section = cue.closest('.hero-wrapper');
    var next = section && section.nextElementSibling;
    if (next && typeof next.scrollIntoView === 'function') {
      next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
